var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geetestWebsite article"},[_c('articleNav'),_c('div',{staticClass:"article-wrap"},[_c('section',_vm._l((_vm.imgSrc),function(item,index){return _c('img',{key:index,attrs:{"src":item.src,"alt":""}})}),0)]),_c('articleInfo',{attrs:{"links":_vm.links,"date":"更新于 2019.9.3"}}),_c('globalFooter'),_c('top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }